import React, { useState } from "react"
import ReactHtmlParser from "react-html-parser"

export default function DesignElementCard({
  clipBoardText,
  clipBoardValue,
  designText,
  image,
  designImageAltText,
  clipBoardCopiedText,
  enableClipboard,
}) {
  //slider goes to parent component. just render card content.
  //get alt texts for images in cards.

  const [timerActive, setTimerActive] = useState(false)

  const handleClick = () => {
    if (clipBoardValue == undefined || clipBoardCopiedText == undefined) return
    navigator.clipboard.writeText(clipBoardValue)

    setTimerActive(true)

    setTimeout(() => {
      setTimerActive(false)
    }, 1300)
  }

  if (enableClipboard)
    return (
      <button onClick={() => handleClick()} onTouchEnd={() => handleClick()} className="design-card">
        <span className={`design-card-tooltip${timerActive ? "-copied" : ""}`}>{timerActive ? clipBoardCopiedText : clipBoardText}</span>
        <div className="design-card-inner-container">
          <div className="image-container">
            <div className="image-container-inner">
              <img src={image} alt={designImageAltText} />
              <div className="rich-text">{ReactHtmlParser(designText)}</div>
            </div>
          </div>
        </div>
      </button>
    )
  else {
    return (
      <div className="design-card">
        <div className="design-card-inner-container">
          <div className="image-container">
            <div className="image-container-inner">
              <img src={image} alt={designImageAltText} />
              <div className="rich-text">{ReactHtmlParser(designText)}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
